export const TRACKING_STATE = 'TRACKING_STATE';

export const trackingSet = tracking => ({ type: TRACKING_STATE, tracking });
